<template>
    <div class="mb-3" :class="type === 'checkbox' ? 'form-check' : 'form-group'">
        <label v-if="label && type !== 'checkbox'" class="form-label" :for="id">{{ label }}:</label>
        <input :id="id" ref="input" v-bind="$attrs"
               :class="[type === 'checkbox' ? 'form-check-input': 'form-control',{error: error }]" :type="type"
               :value="value" @input="$emit('input', type === 'checkbox' ? ($event.target.checked ? '1': '') : $event.target.value)"/>
        <label v-if="label && type === 'checkbox'" class="form-check-label" :for="id">{{ label }}.</label>
        <div v-if="error" class="help-block with-errors">{{ error }}</div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${this._uid}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        value: String,
        label: String,
        error: String,
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end)
        },
    },
}
</script>
